import React, { useState } from "react";
import QuestionCard from "./QuestionCard";
import { QuizResult, QuizQuestion } from "../../shared/types";

interface QuizContainerProps {
  questions: QuizQuestion[];
  onQuizComplete: (results: QuizResult[]) => void;
}

const QuizContainer: React.FC<QuizContainerProps> = ({
  questions,
  onQuizComplete,
}) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [results, setResults] = useState<QuizResult[]>([]);

  const handleAnswerOptionClick = (option: string) => {
    const newResult: QuizResult = {
      question: questions[currentQuestionIndex].question,
      answer: option,
    };

    const updatedResults = [...results, newResult];
    setResults(updatedResults);

    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      onQuizComplete(updatedResults);
    }
  };

  const handleGoBack = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
      setResults(results.slice(0, -1));
    }
  };

  return (
    <QuestionCard
      question={questions[currentQuestionIndex].question}
      options={questions[currentQuestionIndex].options}
      onAnswerOptionClick={handleAnswerOptionClick}
      onGoBack={handleGoBack}
      canGoBack={currentQuestionIndex > 0}
      currentQuestionIndex={currentQuestionIndex + 1}
      totalQuestions={questions.length}
    />
  );
};

export default QuizContainer;
